// pothos manager «Отгрузки» → проверка агрегаторов: менеджер выбирает ассеты,
// ран группирует их (страна × приложение, если связь известна), крон ищет в
// вебе (Gemini grounding) существование приложения и его купонных мерчантов.
// Матрица результатов + клиентский CSV-манифест строятся из aggregatorCheckList.
import { z } from 'zod';

export const POTHOS_AGG_MAX_SELECT = 200;

export const PothosAggCheckStartReqSchema = z.object({
  asset_ids: z.array(z.string().trim().min(1).max(64)).min(1).max(POTHOS_AGG_MAX_SELECT),
});
export type PothosAggCheckStartReq = z.infer<typeof PothosAggCheckStartReqSchema>;

export const PothosAggCheckStartResSchema = z.object({
  run_id: z.string(),
  item_count: z.number(),
  asset_count: z.number(),
  skipped: z.array(z.object({ asset_id: z.string(), reason: z.string() })),
});
export type PothosAggCheckStartRes = z.infer<typeof PothosAggCheckStartResSchema>;

export const PothosAggCheckItemSchema = z.object({
  item_id: z.string(),
  run_id: z.string(),
  country: z.string(),
  app_name: z.string(),
  app_source: z.string(),           // asset_aggregator | ticket_platform | ''
  asset_ids: z.array(z.string()),
  code_types: z.array(z.string()),
  merchants_hint: z.array(z.string()),
  status: z.enum(['pending', 'searching', 'found', 'not_found', 'error']),
  app_exists: z.boolean(),
  app_candidate: z.string(),
  merchants_found: z.array(z.string()),
  search_summary: z.string(),
  sources: z.array(z.object({ uri: z.string(), title: z.string() })),
  tries: z.number(),
  updated_at: z.string(),
});
export type PothosAggCheckItem = z.infer<typeof PothosAggCheckItemSchema>;

export const PothosAggCheckRunSchema = z.object({
  run_id: z.string(),
  created_by: z.string(),
  created_at: z.string(),
  status: z.enum(['pending', 'processing', 'done']),
  asset_count: z.number(),
  item_count: z.number(),
  done_count: z.number(),
});
export type PothosAggCheckRun = z.infer<typeof PothosAggCheckRunSchema>;

export const PothosAggCheckListReqSchema = z.object({
  run_id: z.string().trim().max(64).default(''),
  limit: z.number().int().positive().max(50).default(20),
});
export type PothosAggCheckListReq = z.infer<typeof PothosAggCheckListReqSchema>;

export const PothosAggCheckListResSchema = z.object({
  runs: z.array(PothosAggCheckRunSchema),
  items: z.array(PothosAggCheckItemSchema),
});
export type PothosAggCheckListRes = z.infer<typeof PothosAggCheckListResSchema>;
